import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (consent !== "accepted" && consent !== "rejected") {
      const timer = setTimeout(() => {
        setVisible(true);
        document.body.classList.add("cooki_overlay");
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      document.body.classList.remove("cooki_overlay");
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
    document.body.classList.remove("cooki_overlay");
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setVisible(false);
    document.body.classList.remove("cooki_overlay");
  };

  if (!visible) return null;

  return (
    <div className="cookieess_box" style={{ display: "block" }}>
      <div className="cookieess_box_content">
        <h4>Notice</h4>
        <p>
          The Design Showroom and selected third parties use cookies and
          similar technologies for essential site functionality and, with your
          consent, for enhanced user experience, performance analytics, and
          marketing purposes including personalised advertising, as described
          in our{" "}
          <Link to="/cookie_policy">cookie policy</Link>.
        </p>
        <p>
          You can manage your preferences, give or withdraw consent at any time
          by visiting the settings panel. Please note that disabling some
          cookies may affect your website experience and limit certain
          functionalities.
        </p>
        <p>
          Click “Accept All” to allow all cookies. Click “Reject All” to
          continue with only essential cookies.
        </p>

        <form>
          <div>
            <div>
              <input type="checkbox" id="marketing" />
              <label htmlFor="marketing">Marketing Cookies</label>
            </div>
            <div>
              <input type="checkbox" id="essential" />
              <label htmlFor="essential">Essential Cookies</label>
            </div>
            <div>
              <input type="checkbox" id="analytics" />
              <label htmlFor="analytics">Analytics Cookies</label>
            </div>
          </div>

          <div className="reject_btns">
            <button
              type="button"
              className="closed_coki"
              onClick={handleReject}
            >
              Reject All
            </button>

            <button
              type="button"
              className="closed_coki"
              onClick={handleAccept}
            >
              Accept All
            </button>

            <Link
              to="/gdpr_policy"
              onClick={() => {
                setVisible(false);
                document.body.classList.remove("cooki_overlay");
              }}
            >
              Learn More
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CookieNotice;
